import React from 'react';
import PropTypes from 'prop-types';

const AccountSettingsItem = ({ className, title, description, children }) => {
  return (
    <div className={className} data-testid="account-settings-item">
      <div className="account-settings-item">
        <h3 className="account-settings-item__title">{title}</h3>
        <div className="account-settings-item__body">
          <div className="account-settings-item__side">
            <div className="account-settings-item__description">
              {description}
            </div>
          </div>
          <div className="account-settings-item__side">{children}</div>
        </div>
      </div>
    </div>
  );
};
AccountSettingsItem.propTypes = {
  className: PropTypes.string
};
export default AccountSettingsItem;
